import { createAsyncActions } from "~/utils/store";

export var LOAD_MONTHLY_PAYMENTS = createAsyncActions("@@LOAD_MONTHLY_PAYMENTS");
export var GENERATE_MONTHLY_PAYMENTS = createAsyncActions("@@GENERATE_MONTHLY_PAYMENTS");
export var MARK_AS_DEFAULTING = createAsyncActions("@@MARK_AS_DEFAULTING");
export var MARK_AS_PROCESSED = createAsyncActions("@@MARK_AS_PROCESSED");
export var DELETE_HONORARY = createAsyncActions("@@DELETE_HONORARY");
export var BULK_DELETE_HONORARY = createAsyncActions("@@BULK_DELETE_HONORARY");

export var loadPayments = function(params) {
  var filter_by = params.filter_by;
  var from = params.from;
  var to = params.to;
  var status = params.status;
  var customer_id = params.customer_id;

  return {
    type: LOAD_MONTHLY_PAYMENTS.INIT,
    payload: {
      request: {
        method: "get",
        url: "/monthly/payments?filter_by=" + filter_by + "&from=" + from + "&to=" + to + "&status=" + status + "&customer_id=" + customer_id
      },
      filter: {
        from: from,
        to: to,
        status: status,
        filter_by: filter_by,
        customer_id: customer_id
      }
    }
  };
};

export const monthlyGenerate = (data) => ({
  type: GENERATE_MONTHLY_PAYMENTS.INIT,
  payload: {
    request: {
      method: "post",
      url: "/monthly/payments",
      data,
    },
  },
});

export const markAsDefaulting = (id) => ({
  type: MARK_AS_DEFAULTING.INIT,
  payload: {
    request: {
      method: "put",
      url: `/monthly/payments/${id}/defaulting`,
    },
  },
  id,
});

export const markAsProcessed = (id) => ({
  type: MARK_AS_PROCESSED.INIT,
  payload: {
    request: {
      method: "put",
      url: `/monthly/payments/${id}/processed`,
    },
  },
  id,
});

export var deleteHonorary = function(id) {
  return {
    type: DELETE_HONORARY.INIT,
    payload: {
      request: {
        method: "delete",
        url: "/monthly/payments/" + id
      }
    },
    id: id
  };
};

export var bulkDeleteHonorary = function(ids) {
  return {
    type: BULK_DELETE_HONORARY.INIT,
    payload: {
      request: {
        method: "post",
        url: "/monthly/payments/bulk-delete",
        data: { ids: ids }
      }
    },
    ids: ids
  };
};